import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  const { t, isRTL } = useLang();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top-button"
      aria-label={t.common.backToTop}
      className={`fixed bottom-24 z-40 inline-flex items-center justify-center w-12 h-12 bg-maroon-600 hover:bg-maroon-500 text-white border border-maroon-400/60 transition-all duration-300 ${
        isRTL ? "left-6" : "right-6"
      } ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
      style={{ boxShadow: "0 10px 30px rgba(193,18,31,0.35)" }}
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
